import { useEffect } from 'react';
import axios from 'axios';
import 'react-toastify/dist/ReactToastify.css';
import { security_key, Url } from '../../Services/Api';

const useTokenVerification = (updateToastMessage) => {
    const handleLogout = () => {
        sessionStorage.removeItem('authToken');
        window.location.href = '/';
    };

    const verifyToken = async () => {
        const token = sessionStorage.getItem('authToken');
        let toastMessage;

        if (!token) {
            handleLogout();
            return;
        }

        try {
            const headers = {
                Authorization: `Bearer ${token}`,
                'x-api-key': security_key, // if using the security key
            };


            const response = await axios.get(`${Url}/api/v1/users/verify-token`, { headers });

            if (response.data.message === 'Token is valid.') {
                toastMessage = "Token is valid!";
                updateToastMessage(toastMessage);
            } else {
                toastMessage = "Token verification failed!";
                updateToastMessage(toastMessage);
                handleLogout();
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                toastMessage = "Unauthorized: Invalid token!";
                updateToastMessage(toastMessage);
                handleLogout();
            } else {
                toastMessage = `Token verification error: ${error.message}!`;
                updateToastMessage(toastMessage);
                handleLogout();
            }
        }
    };

    const notifySessionExpiration = () => {
        const message = "Alert: Your session has been logged out soon... Be ready to Re-Login!";
        updateToastMessage(message);
    };

    useEffect(() => {
        const token = sessionStorage.getItem('authToken');
        if (token) {
            const intervalId = setInterval(verifyToken, 900000);
            const notifyTimeoutId = setTimeout(notifySessionExpiration, 3300000);
            return () => {
                clearInterval(intervalId);
                clearTimeout(notifyTimeoutId);
            };
        }
    }, [updateToastMessage]);

    return null;
};

export default useTokenVerification;